import React from 'react';

interface SparklinePoint {
  time: string;
  price: number;
  is_catalyst_event?: boolean;
}

interface SignalSparklineProps {
  chartData?: SparklinePoint[];
  currentPrice: number;
  changePct: number;
}

export function SignalSparkline({ chartData, currentPrice, changePct }: SignalSparklineProps) {
  const isPositive = changePct >= 0;

  // שימוש בנתוני אמת מהשרת או פולבק לנקודה אחת אופקית אם אין נתונים
  const chartPoints = chartData && chartData.length > 0 
    ? chartData 
    : [{ time: '', price: currentPrice }];

  const prices = chartPoints.map(p => p.price);
  const minPrice = Math.min(...prices) * 0.995; // מרווח ביטחון קטן מלמטה
  const maxPrice = Math.max(...prices) * 1.005; // מרווח ביטחון קטן מלמעלה
  const priceRange = maxPrice - minPrice || 1;  // מניעת חלוקה באפס

  // מידות קטנות ונוחות שמתאימות לתוך תא בטבלה
  const width = 120;
  const height = 35;

  // חישוב קורדינטות ה-SVG בדינמיות
  const points = chartPoints.map((point, index) => {
    const x = chartPoints.length > 1 ? (index / (chartPoints.length - 1)) * width : width;
    const y = height - ((point.price - minPrice) / priceRange) * height;
    return { x, y };
  });

  // יצירת הנתיב (Path) של הקו
  const pathD = points.length > 1 
    ? points.map((p, i) => `${i === 0 ? 'M' : 'L'} ${p.x} ${p.y}`).join(' ')
    : `M 0 ${points[0].y} L ${width} ${points[0].y}`;

  // צבע הקו: ירוק לעליות, אדום לירידות
  const strokeColor = isPositive 
    ? 'stroke-emerald-500 dark:stroke-emerald-400' 
    : 'stroke-red-500 dark:stroke-red-400';

  return (
    <div className="w-[120px] h-[35px] flex items-center">
      <svg 
        viewBox={`0 0 ${width} ${height}`} 
        width={width} 
        height={height} 
        className="overflow-visible"
      >
        <path 
          d={pathD} 
          fill="none" 
          className={strokeColor} 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round" 
        />
      </svg>
    </div>
  );
}